export default __webpack_public_path__ + "static/Sourceforge-3461705a6845fe4c07c2767067b6db22.webp";